const HEADER_HEIGHT = 37;
const NODE_HEIGHT = 67;

export const isPointerInsideContainer = (e: MouseEvent, container: DOMRect) => {
  if (!container) return false;

  const { clientX, clientY } = e;

  return (
    clientX > container.x &&
    clientX < container.x + container.width &&
    clientY > container.y &&
    clientY < container.y + container.height
  );
};

export const findIndexOfHoveredNode = (
  e: MouseEvent,
  container: DOMRect,
  topScrollOffset: number,
) => {
  if (!container) return -1;

  if (!isPointerInsideContainer(e, container)) return -1;

  const { clientY } = e;

  const mousePositionInsideContainerY = clientY - container.y + topScrollOffset;

  if (mousePositionInsideContainerY < HEADER_HEIGHT) return -1;

  return Math.floor(
    (mousePositionInsideContainerY - HEADER_HEIGHT) / NODE_HEIGHT,
  );
};

export const findFirstIndexForSelectedNode = (
  e: MouseEvent,
  container: DOMRect,
  topScrollOffset: number,
) => {
  if (isPointerInsideContainer(e, container)) return -1;

  const { clientY } = e;

  const mousePositionInsideContainerY = clientY - container.y + topScrollOffset;

  if (mousePositionInsideContainerY < HEADER_HEIGHT) return -1;

  return Math.floor(
    (mousePositionInsideContainerY - HEADER_HEIGHT) / NODE_HEIGHT,
  );
};

export const findIndexesForSelection = (
  start: MouseEvent,
  end: MouseEvent,
  container: DOMRect,
  startTopOffset: number,
  endTopOffset: number,
) => {
  if (!isPointerInsideContainer(end, container)) return;

  const firstIndex = findFirstIndexForSelectedNode(
    start,
    container,
    startTopOffset,
  );

  const lastIndex = findIndexOfHoveredNode(end, container, endTopOffset);

  return indexRange(
    Math.min(firstIndex, lastIndex),
    Math.max(firstIndex, lastIndex),
  );
};

const indexRange = (min: number, max: number) => {
  const len = max - min + 1;
  const arr = new Array(len);

  for (let i = 0; i < len; i++) {
    arr[i] = min + i;
  }

  return arr;
};
